import Flatpickr from 'stimulus-flatpickr'

export default class extends Flatpickr {
  connect() {
    this.config = {
      locale: {
        firstDayOfWeek: 1
      },
    };

    super.connect();
  }
}
